import React, {useState} from "react"
import {Btn, FormInput, Modal} from "./";
import {useCore} from "../hooks";
import {updateBill, OrderItemType, formatDate} from "../utils";
import {OrderItem, Voucher} from "depoto-core";

export const ModalVoucherCreate: React.FC = () => {
  const { currentOrder, setCurrentOrder, vats } = useCore()
  const [isVisible, setIsVisible] = useState<boolean>(false)
  const [code, setCode] = useState<string>('')
  const [amount, setAmount] = useState<number>(0)
  const defaultVat = () => vats?.find(v => v.default)

  const openModal = () => {
    setIsVisible(true)
  }

  const closeModal = () => {
    setCode('')
    setAmount(0)
    setIsVisible(false)
  }

  const createVoucher = () => {
    const nextOrder = {...currentOrder}
    const vat = defaultVat()
    const validTill = new Date()
    const defaultVoucherValidity = Number(window.localStorage.getItem('depoto_checkout2_default_voucher_validity'))
    if (defaultVoucherValidity > 0) {
      validTill.setMonth(validTill.getMonth() + defaultVoucherValidity)
    } else {
      validTill.setMonth(validTill.getMonth() + 6)
    }
    const orderItem = new OrderItem({
      type: OrderItemType.voucherToCreate, // type product on send.. todo: when creating order, create vouchers && change type to 'product'
      name: `Poukaz - Kód: ${code}, hodnota: ${amount}, platnost do: ${formatDate(validTill, false)}`,
      price: amount,
      priceWithoutVat: amount * vat.coefficient,
      code,
      quantity: 1,
      isForSubsequentSettlement: true,
      expirationDate: formatDate(validTill), // todo when creating order, set as validity date!
      vat,
    })
    console.log({orderItem}) // todo delete
    updateBill({ currentOrder: nextOrder, setCurrentOrder, orderItem })
    closeModal()
  }

  const generateCode = () => {
    const disallowed = ['0', 'o', '1', 'l', 'i', 'j', '6', 'g', '8', 'b']
    const g = c => {
      const r = (d + Math.random() * 16) % 16 | 0
      d = Math.floor(d / 16)
      const ir = (c == 'x' ? r : (r & 0x3 | 0x8)).toString(16)
      if (disallowed.includes(ir)) {
        return g(c)
      }
      return ir
    }
    let d = new Date().getTime()
    if (window.performance && typeof window.performance.now === "function") {
      d += performance.now() //use high-precision timer if available
    }
    const c = 'xxyxxxyx'.replace(/[xy]/g, c => g(c))
    setCode(c.toUpperCase())
  }

  return (
    <Modal
      modalOpenBtn={<Btn className="btn-link font-bold" children={'Prodej kupónu'} onClick={openModal} />}
      isVisible={isVisible}
      modalTitle={'Prodej kupónu'}
      modalWidth={'sm'}
      onClose={closeModal}
      content={
        <div>
          <FormInput label={'Kód'} value={code} onChange={e => setCode(e)} />
          <Btn className="btn-base-100" icon={'fa-tag'} children={'Generovat kód'} onClick={generateCode}/>
          <FormInput label={'Částka'} value={`${amount}`} onChange={e => setAmount(Number(e))} />
        </div>
      }
      footerContent={
        <div className="flex flex-row justify-between items-center">
          <Btn className="btn-base-100" icon={'fa-times'} children={'Zrušit'} onClick={() => setIsVisible(false)}/>
          <Btn className="btn-primary" icon={'fa-check'} children={'Přidat kupón'} onClick={createVoucher}/>
        </div>
      }
    />
  )
}
